import { render, staticRenderFns } from "./TinyLoaderLight.vue?vue&type=template&id=214d728c&scoped=true&"
import script from "./TinyLoaderLight.vue?vue&type=script&lang=js&"
export * from "./TinyLoaderLight.vue?vue&type=script&lang=js&"
import style0 from "./TinyLoaderLight.vue?vue&type=style&index=0&id=214d728c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d728c",
  null
  
)

export default component.exports